export class CurrentUserDto {
    id = "";
    name = "";
    permissions = [];
    email = "";
    defaultRoute = "";
}

export class CurrentUserState {
    loading = false;
    error = null;
    record: CurrentUserDto = null;
}
